/* eslint-disable no-unused-vars */
import ChooseMain from './components/ChooseMain';
import { useDispatch, useSelector } from 'react-redux';
import SectionLayout from 'components/common/SectionLayout';
import { userAgentsOSType } from 'store/selectors';
import { generalActions, targetingPlacementsActions } from 'store/actions';
import { RadioBoxGroup, RightSideContainer } from '../../components';
import { RadioBox, Label } from 'components';

export default function TargetingOngoingDevicesOS() {
  const dispatch = useDispatch();

  const userAgents_os_type = useSelector(userAgentsOSType);
  const handleChange = (newValue) => {
    if (+userAgents_os_type === +newValue) return;
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSMinVer',
        newValue: 32,
      }),
    );
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSList',
        newValue: '',
      }),
    );
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'userAgentsOSType',
        newValue: +newValue,
      }),
    );
    if (+newValue !== 2) {
      dispatch(
        targetingPlacementsActions.updateErrorField({
          errorField: 'os',
          newValue: false,
        }),
      );
    }
  };

  return (
    <SectionLayout
      noSeparator={true}
      noBottomPadding={true}
      leftSide={<Label text='OS Versions:' variant='label' style={{ marginTop: '8px' }} />}
      rightSide={
        <RightSideContainer>
          <RadioBoxGroup>
            <RadioBox.NormalSize
              onChange={handleChange}
              label='Minimum Version'
              width={158}
              variant='left'
              value={1}
              pressed={+userAgents_os_type === 1}
            />
            <RadioBox.NormalSize
              onChange={handleChange}
              label='Specific Versions'
              width={156}
              variant='right'
              value={2}
              pressed={+userAgents_os_type === 2}
            />
          </RadioBoxGroup>
          <ChooseMain selectedType={userAgents_os_type} />
        </RightSideContainer>
      }
    />
  );
}
